import Cookies from 'universal-cookie'
import { cookieSettings } from 'gatsby-theme-kn/src/utils/partner_portal_spa'

const cookies = new Cookies()
const shoppingCartCookieName = 'shopping_cart'

export function shoppingCartCount() {
  return shoppingCartList().length
}

export function clearShoppingCart(setter) {
  cookies.remove(shoppingCartCookieName, cookieSettings())
  setter(shoppingCartList())
}

export function shoppingCartList() {
  let content = cookies.get(shoppingCartCookieName)
  return content || []
}

export function addUploadToShoppingCart(uploadId, setter) {
  let quantity =
    parseInt(document.getElementById('amount-' + uploadId).value) || 1
  let type =
    document.getElementById('amount-' + uploadId).getAttribute('data-type') ||
    'upload'
  let max = parseInt(document.getElementById('amount-' + uploadId).max)

  if (max == 0 || max < 0) {
    return
  }

  let content = shoppingCartList()
  let index = _getIndexByParam(content, uploadId)

  if (index >= 0) {
    if (content[index][1] + quantity > max) {
      content[index] = [uploadId, max, type]
      document.getElementById('amount-' + uploadId).value = max
    } else {
      let new_quantity = content[index][1] + quantity
      content[index] = [uploadId, new_quantity, type]
      document.getElementById('amount-' + uploadId).value = new_quantity
    }
  } else {
    if (quantity > max) {
      content.push([uploadId, max, type])
    } else {
      content.push([uploadId, quantity, type])
    }
  }
  cookies.set(shoppingCartCookieName, content, cookieSettings())
  setter(shoppingCartList())
}

export function removeUploadFromShoppingCart(uploadId, setter) {
  let content = shoppingCartList()
  let index = _getIndexByParam(content, uploadId)

  if (index >= 0) {
    content.splice(index, 1)
    cookies.set(shoppingCartCookieName, content, cookieSettings())
  }
  setter(shoppingCartList())
}

export function changeUploadQuantity(uploadId, subtractor, setter) {
  let content = shoppingCartList()
  let index = _getIndexByParam(content, uploadId)
  if (index >= 0) {
    let old_quantity = content[index][1]
    let upload_type = content[index][2] || 'upload'

    let max = parseInt(document.getElementById('amount-' + uploadId).max)
    if (old_quantity + subtractor > 0) {
      if (old_quantity + subtractor <= max) {
        content[index] = [
          content[index][0],
          old_quantity + subtractor,
          upload_type,
        ]
        document.getElementById('amount-' + uploadId).value =
          old_quantity + subtractor
        cookies.set(shoppingCartCookieName, content, cookieSettings())
        setter(shoppingCartList())
      }
    } else {
      // Anzahl <= 0, d.h. Item aus ShoppingCart entfernen
      removeUploadFromShoppingCart(uploadId, setter)
    }
  }
}

export function setUploadQuantity(uploadId, quantity, setter) {
  let content = shoppingCartList()
  let index = _getIndexByParam(content, uploadId)
  if (index >= 0) {
    let old_quantity = content[index][1]
    let upload_type = content[index][2] || 'upload'
    let subtractor = (old_quantity - quantity) * -1
    return changeUploadQuantity(uploadId, subtractor, setter)
  }
}

function _getIndexByParam(content, param) {
  var index = -1
  content.map(function (element, i) {
    if (element[0] === param) index = i
  })
  return index
}
